import { render, staticRenderFns } from "./TermsBackMatter.vue?vue&type=template&id=45a43445&scoped=true"
import script from "./TermsBackMatter.vue?vue&type=script&lang=ts"
export * from "./TermsBackMatter.vue?vue&type=script&lang=ts"
import style0 from "./TermsBackMatter.vue?vue&type=style&index=0&id=45a43445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a43445",
  null
  
)

export default component.exports